import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input'];

  static values = {
    original: String,
  };

  reset() {
    this.inputTarget.value = this.originalValue;
  }
}
